// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CriteriaFilterBase, CriteriaFilterBaseSchema } from 'api/gen/CriteriaFilterBase';

const requiredPart = t.interface({
  tag: t.literal('BOOL'),
  value: t.boolean,
});

export const CriteriaBooleanFilterSchema = excess(t.intersection([CriteriaFilterBaseSchema.type, requiredPart]));

export interface CriteriaBooleanFilter extends t.TypeOf<typeof CriteriaBooleanFilterSchema> {}
